import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e29d1a42&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e29d1a42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29d1a42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e29d1a42')) {
      api.createRecord('e29d1a42', component.options)
    } else {
      api.reload('e29d1a42', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e29d1a42&scoped=true", function () {
      api.rerender('e29d1a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabCollapse/index.vue"
export default component.exports